import {
  HIDE_LOADER,
  SHOW_LOADER,
  SET_AUTHORIZE,
} from "../actions/app-action-types";

const initialState = { visible: false, isUnauthorize: false };

export default function app(state = initialState, { type, payload }) {
  if (
    payload?.error?.response?.status === 401 ||
    payload?.error?.networkError?.response?.status === 401
  ) {
    return { ...state, isUnauthorize: true };
  }
  switch (type) {
    case HIDE_LOADER:
      return { ...state, visible: false };
    case SHOW_LOADER:
      return { ...state, visible: true };
    case SET_AUTHORIZE:
      return { ...state, isUnauthorize: false };
    default:
      return state;
  }
}
